(function () {
  'use strict';

  if (window.__AK_PERFORMANCE_MANAGER__) return;
  window.__AK_PERFORMANCE_MANAGER__ = true;

  /* Query-gated diagnostics for measuring the real intro on the visitor's
     current machine. It stays completely inactive during normal browsing. */
  if (/(?:\?|&)akperf=1(?:&|$)/.test(window.location.search)) {
    (function initAkIntroDiagnostics() {
      var reportNode = document.createElement('script');
      var startedAt = window.performance.now();
      var lastFrameAt = startedAt;
      var frameCount = 0;
      var slowFrames = [];
      var longTasks = [];
      var longAnimationFrames = [];
      var phases = [];
      var papersStages = [];
      var lastPublishAt = 0;

      reportNode.id = 'ak-intro-performance-report';
      reportNode.type = 'application/json';
      (document.head || document.documentElement).appendChild(reportNode);

      function elapsed(now) {
        return Math.round((now - startedAt) * 10) / 10;
      }

      function recordPhase(name) {
        phases.push({
          name: name,
          at: elapsed(window.performance.now()),
          bodyClass: document.body ? document.body.className : ''
        });
        publish(true);
      }

      function publish(force) {
        var now = window.performance.now();
        if (!force && now - lastPublishAt < 400) return;
        lastPublishAt = now;

        var orderedSlowFrames = slowFrames
          .slice()
          .sort(function (a, b) { return b.duration - a.duration; })
          .slice(0, 40);

        reportNode.textContent = JSON.stringify({
          elapsed: elapsed(now),
          navigation: performance.getEntriesByType('navigation').map(function (entry) {
            return {responseEnd: entry.responseEnd, domReady: entry.domContentLoadedEventEnd, load: entry.loadEventEnd};
          }),
          boot: window.AK_BOOT ? {
            started: window.AK_BOOT.started, finished: window.AK_BOOT.finished,
            tasks: window.AK_BOOT.tasks, assets: window.AK_BOOT.assetReadiness,
            carousels: window.AK_BOOT.carouselReadiness
          } : null,
          inlineScriptBytes: Array.from(document.scripts).reduce(function (sum, script) { return sum + script.textContent.length; }, 0),
          resources: performance.getEntriesByType('resource').slice().sort(function (a, b) { return b.duration - a.duration; }).slice(0, 12).map(function (entry) {
            return {url: entry.name.split('?')[0], start: entry.startTime, duration: entry.duration};
          }),
          frameCount: frameCount,
          slowFrameCount: slowFrames.length,
          worstFrames: orderedSlowFrames,
          longTasks: longTasks.slice(-40),
          longAnimationFrames: longAnimationFrames.slice(-30),
          papersStages: papersStages,
          phases: phases.slice(-80)
        });
      }

      function frame(now) {
        var duration = now - lastFrameAt;
        lastFrameAt = now;
        frameCount += 1;

        if (duration > 20) {
          slowFrames.push({
            at: elapsed(now),
            duration: Math.round(duration * 10) / 10
          });
        }

        publish(false);
        window.requestAnimationFrame(frame);
      }

      if ('PerformanceObserver' in window) {
        try {
          var longTaskObserver = new PerformanceObserver(function (list) {
            list.getEntries().forEach(function (entry) {
              longTasks.push({
                at: Math.round(entry.startTime * 10) / 10,
                duration: Math.round(entry.duration * 10) / 10
              });
            });
            publish(true);
          });
          longTaskObserver.observe({ type: 'longtask', buffered: true });
        } catch (error) {}

        try {
          if (
            PerformanceObserver.supportedEntryTypes &&
            PerformanceObserver.supportedEntryTypes.indexOf('long-animation-frame') !== -1
          ) {
            var animationFrameObserver = new PerformanceObserver(function (list) {
              list.getEntries().forEach(function (entry) {
                longAnimationFrames.push({
                  at: Math.round(entry.startTime * 10) / 10,
                  duration: Math.round(entry.duration * 10) / 10,
                  blockingDuration: Math.round((entry.blockingDuration || 0) * 10) / 10,
                  scripts: Array.prototype.slice.call(entry.scripts || [], 0, 8).map(function (script) {
                    return {
                      duration: Math.round((script.duration || 0) * 10) / 10,
                      functionName: script.sourceFunctionName || script.functionName || '',
                      sourceCharPosition: script.sourceCharPosition,
                      sourceURL: script.sourceURL || '',
                      invoker: script.invoker || ''
                    };
                  })
                });
              });
              publish(true);
            });
            animationFrameObserver.observe({ type: 'long-animation-frame', buffered: true });
          }
        } catch (error) {}
      }

      function observeBody() {
        if (!document.body) return;

        var lastClass = document.body.className;
        phases.push({ name: 'body-ready', at: elapsed(window.performance.now()), bodyClass: lastClass });

        new MutationObserver(function () {
          if (document.body.className === lastClass) return;
          lastClass = document.body.className;
          recordPhase('body-class-change');
        }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

        document.addEventListener('click', function (event) {
          if (event.target.closest('.ak-film-simple-section, .ak-film-access-label')) {
            recordPhase('tap-to-access');
          }
        }, true);
      }

      function observePapersEntrance() {
        var divider = document.querySelector('[data-ak-paper-intro]');
        var carousel = document.querySelector('section.ak-featured-carousel');
        if (!divider || !carousel) return;
        function sample() {
          papersStages.push({state: divider.dataset.akPaperIntro, at: performance.now(),
            dividerHeight: divider.getBoundingClientRect().height, carouselTop: carousel.getBoundingClientRect().top});
          publish(true);
        }
        sample();
        new MutationObserver(sample).observe(divider, {attributes:true, attributeFilter:['data-ak-paper-intro']});
      }
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observePapersEntrance, {once:true});
      else observePapersEntrance();

      if (document.body) observeBody();
      else document.addEventListener('DOMContentLoaded', observeBody, { once: true });

      [
        'ak:boot-ready',
        'ak:boot-revealed',
        'ak:global-frame-ready',
        'ak:papers-editorial-cta-ready',
        'ak:film-removed',
        'ak:home-film-frame-ready',
        'ak:home-frame-ready',
        'ak:home-sticky-stage-landed'
      ].forEach(function (name) {
        window.addEventListener(name, function () { recordPhase(name); });
      });

      recordPhase('diagnostics-start');
      window.requestAnimationFrame(frame);
    })();
  }

  var managedVideos = new WeakSet();
  var managedAnimations = new WeakSet();
  var managedPromotions = new WeakSet();
  var promotionElements = [];

  function isRenderable(element) {
    if (!element || !element.isConnected) return false;

    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Number(style.opacity) !== 0 &&
      rect.width > 0 &&
      rect.height > 0
    );
  }

  function isNearViewport(element, margin) {
    if (!element || !element.isConnected) return false;

    var rect = element.getBoundingClientRect();
    var buffer = Number(margin) || 0;

    return (
      rect.bottom >= -buffer &&
      rect.top <= window.innerHeight + buffer &&
      rect.right >= 0 &&
      rect.left <= window.innerWidth
    );
  }

  function safelyPlay(video, visibilityChecked) {
    if (!video || !video.paused || document.hidden || (!visibilityChecked && !isRenderable(video))) {
      return;
    }

    var playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  var videoObserver = new IntersectionObserver(
    function (entries) {
      if (window.AK_NATIVE_ZOOM?.isZooming()) return;
      // The observer already supplies viewport membership. Read visibility
      // for the batch before play/pause or dataset changes can dirty layout.
      var states = entries.map(function (entry) {
        return { video: entry.target, run: entry.isIntersecting && entry.intersectionRatio > 0 &&
          !document.hidden && isRenderable(entry.target) };
      });
      states.forEach(function (state) {
        var value = state.run ? 'true' : 'false';
        if (state.video.dataset.akPerformanceInView !== value) {
          state.video.dataset.akPerformanceInView = value;
        }
        if (state.run) safelyPlay(state.video, true);
        else if (!state.video.paused) state.video.pause();
      });
    },
    // Keep a positive crossing as well as edge contact: an observer can
    // report isIntersecting=true with a zero-area intersection at the edge.
    { rootMargin: '0px', threshold: [0, 0.001] }
  );

  function manageVideo(video) {
    if (
      !video ||
      managedVideos.has(video) ||
      !video.matches('video[autoplay]') ||
      video.matches('.ak-film-simple-video, [data-ak-playback-owner="gallery-mobile"]')
    ) {
      return;
    }

    managedVideos.add(video);
    video.dataset.akPerformanceInView =
      isNearViewport(video, 0) && isRenderable(video) ? 'true' : 'false';
    videoObserver.observe(video);

    if (video.dataset.akPerformanceInView === 'true') safelyPlay(video);

    video.addEventListener('play', function () {
      // This event follows our own play() call. Re-reading layout here used
      // to flush all styles just written by the intersection callback.
      if (document.hidden || video.dataset.akPerformanceInView !== 'true') {
        if (!video.paused) video.pause();
      }
    });

    video.addEventListener('loadedmetadata', queueViewportSync);
    video.addEventListener('canplay', queueViewportSync);
  }

  var animationSelector = [
    '.ak-boot-screen__logo',
    'section.ak-featured-carousel--astrobear .relative.aspect-media.rounded-grid-media',
    'section.ak-featured-carousel .ak-featured-explore-text span',
    'section.ak-featured-carousel .ak-mobile-fifth-explore-text span',
    '.ak-galleryportal-hatch-v8__touch-text',
    'section.ak-featured-carousel .ak-catalogue-entry-emblem > svg',
    'section.ak-featured-carousel .ak-catalogue-entry-rotor'
  ].join(',');

  function isHomeFirstCarouselBreathing(element) {
    return !!(
      element &&
      element.matches(
        'section.ak-home-first-featured.ak-featured-carousel--astrobear ' +
        '.ak-astrobear-living-slide image-with-placeholder'
      )
    );
  }

  function keepHomeBreathingActive(element) {
    if (!isHomeFirstCarouselBreathing(element)) return false;
    // Only keep the underlying first carousel alive while its intro is
    // actually on screen. Pausing retains its angle/phase on return.
    var intro = document.querySelector('.ak-film-simple-section');
    return !document.hidden && !!intro && isNearViewport(intro, 0) && isRenderable(intro);
  }

  var promotionScopeSelector = [
    '.ak-film-simple-section',
    'section.ak-featured-carousel',
    '.ak-galleryportal-hatch-v8',
    '.ak-longcenter-short-desktop',
    '.ak-theend-v2-desktop',
    '.ak-theend-v2-mobile',
    '.ak-kp-logo',
    '.ak-ca-desktop-box',
    '.ak-cart-panel'
  ].join(',');

  function pauseAnimation(element) {
    if (!element.dataset.akPerformanceAnimationState) {
      element.dataset.akPerformanceAnimationState =
        element.style.getPropertyValue('animation-play-state') || '__empty__';
      element.dataset.akPerformanceAnimationPriority =
        element.style.getPropertyPriority('animation-play-state') || '__empty__';
    }

    element.style.setProperty('animation-play-state', 'paused', 'important');
    element.style.setProperty('will-change', 'auto', 'important');
  }

  function resumeAnimation(element) {
    var value = element.dataset.akPerformanceAnimationState;
    var priority = element.dataset.akPerformanceAnimationPriority;

    if (!value) {
      element.style.removeProperty('animation-play-state');
    } else if (value === '__empty__') {
      element.style.removeProperty('animation-play-state');
    } else {
      element.style.setProperty(
        'animation-play-state',
        value,
        priority === '__empty__' ? '' : priority
      );
    }

    element.style.removeProperty('will-change');
  }

  var animationObserver = new IntersectionObserver(
    function (entries) {
      if (window.AK_NATIVE_ZOOM?.isZooming()) return;
      var states = entries.map(function (entry) {
        return { element: entry.target, run: keepHomeBreathingActive(entry.target) ||
          (entry.isIntersecting && !document.hidden && isRenderable(entry.target)) };
      });
      states.forEach(function (state) {
        var value = state.run ? 'true' : 'false';
        if (state.element.dataset.akPerformanceAnimationInView === value) return;
        state.element.dataset.akPerformanceAnimationInView = value;
        if (state.run) resumeAnimation(state.element);
        else pauseAnimation(state.element);
      });
    },
    { rootMargin: '0px', threshold: 0 }
  );

  // A final catalogue slide can become visible without moving its bounds
  // (its text reveal is a class change). Resume then as well as on intersection.
  var catalogueSections = new WeakSet();
  var catalogueVisibility = new MutationObserver(queueViewportSync);
  function manageAnimation(element) {
    if (!element || managedAnimations.has(element)) return;

    managedAnimations.add(element);
    if (element.matches('section.ak-featured-carousel .ak-catalogue-entry-emblem > svg, section.ak-featured-carousel .ak-catalogue-entry-rotor')) {
      var section = element.closest('section.ak-featured-carousel');
      if (section && !catalogueSections.has(section)) {
        catalogueSections.add(section);
        catalogueVisibility.observe(section,{attributes:true,attributeFilter:['class']});
      }
    }
    element.dataset.akPerformanceAnimationInView =
      keepHomeBreathingActive(element) ||
      (isNearViewport(element, 0) && isRenderable(element)) ? 'true' : 'false';
    animationObserver.observe(element);

    if (element.dataset.akPerformanceAnimationInView === 'true') {
      resumeAnimation(element);
    } else {
      pauseAnimation(element);
    }
  }

  function releasePromotion(element) {
    element.style.setProperty('will-change', 'auto', 'important');
  }

  function restorePromotion(element) {
    var value = element.dataset.akPerformanceWillChange;
    var priority = element.dataset.akPerformanceWillChangePriority;

    if (!value || value === '__empty__') {
      element.style.removeProperty('will-change');
    } else {
      element.style.setProperty(
        'will-change',
        value,
        priority === '__empty__' ? '' : priority
      );
    }
  }

  var promotionObserver = new IntersectionObserver(
    function (entries) {
      if (window.AK_NATIVE_ZOOM?.isZooming()) return;
      entries.forEach(function (entry) {
        var shouldPromote =
          (entry.isIntersecting || isNearViewport(entry.target, 600)) &&
          !document.hidden &&
          isRenderable(entry.target);

        if (shouldPromote) {
          restorePromotion(entry.target);
        } else {
          releasePromotion(entry.target);
        }
      });
    },
    {
      rootMargin: '600px 0px',
      threshold: 0
    }
  );

  function managePromotion(element) {
    if (!element || managedPromotions.has(element)) return;

    var computedWillChange = window.getComputedStyle(element).willChange;
    if (!computedWillChange || computedWillChange === 'auto') return;

    managedPromotions.add(element);
    promotionElements.push(element);
    element.dataset.akPerformanceWillChange =
      element.style.getPropertyValue('will-change') || '__empty__';
    element.dataset.akPerformanceWillChangePriority =
      element.style.getPropertyPriority('will-change') || '__empty__';

    promotionObserver.observe(element);

    if (
      !document.hidden &&
      isNearViewport(element, 600) &&
      isRenderable(element)
    ) {
      restorePromotion(element);
    } else {
      releasePromotion(element);
    }
  }

  function scanPromotions(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var containers = [];

    if (
      root &&
      root.nodeType === 1 &&
      root.matches(promotionScopeSelector)
    ) {
      containers.push(root);
    }

    scope.querySelectorAll(promotionScopeSelector).forEach(function (container) {
      containers.push(container);
    });

    containers.forEach(function (container) {
      managePromotion(container);
      container.querySelectorAll('*').forEach(managePromotion);
    });
  }

  function syncPromotions() {
    if (window.AK_NATIVE_ZOOM?.isZooming()) return;
    promotionElements = promotionElements.filter(function (element) {
      if (!element.isConnected) return false;

      if (
        !document.hidden &&
        isNearViewport(element, 600) &&
        isRenderable(element)
      ) {
        restorePromotion(element);
      } else {
        releasePromotion(element);
      }

      return true;
    });
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (root && root.nodeType === 1) {
      if (root.matches('video[autoplay]')) manageVideo(root);
      if (root.matches(animationSelector)) manageAnimation(root);
    }

    scope
      .querySelectorAll('video[autoplay]:not(.ak-film-simple-video):not([data-ak-playback-owner="gallery-mobile"])')
      .forEach(manageVideo);
    scope.querySelectorAll(animationSelector).forEach(manageAnimation);
  }

  function syncViewport() {
    if (window.AK_NATIVE_ZOOM?.isZooming()) return;
    // Collect geometry before changing any styles. Interleaving these reads
    // and writes forced a full layout for each animation during scrolling.
    var videos = Array.from(document.querySelectorAll('video[autoplay]:not(.ak-film-simple-video):not([data-ak-playback-owner="gallery-mobile"])'))
      .map(function (video) {
        return { element: video, run: !document.hidden && isNearViewport(video, 0) && isRenderable(video) };
      });
    var animations = Array.from(document.querySelectorAll(animationSelector))
      .map(function (element) {
        return { element: element, run: keepHomeBreathingActive(element) ||
          (!document.hidden && isNearViewport(element, 0) && isRenderable(element)) };
      });
    videos.forEach(function (state) {
      var video = state.element;
      video.dataset.akPerformanceInView = state.run ? 'true' : 'false';
      if (!state.run) { if (!video.paused) video.pause(); }
      else if (video.paused) {
        // Visibility was checked above; avoid a second layout after writes.
        var promise = video.play();
        if (promise && promise.catch) promise.catch(function () {});
      }
    });
    animations.forEach(function (state) {
      state.element.dataset.akPerformanceAnimationInView = state.run ? 'true' : 'false';
      if (state.run) resumeAnimation(state.element);
      else pauseAnimation(state.element);
    });
  }

  var viewportFrame = null;

  function queueViewportSync() {
    if (window.AK_NATIVE_ZOOM?.isZooming()) return;
    if (viewportFrame !== null) return;

    viewportFrame = requestAnimationFrame(function () {
      viewportFrame = null;
      syncViewport();
    });
  }

  function init() {
    scan(document);

    var mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            scan(node);
          }
        });
      });
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    syncViewport();

    requestAnimationFrame(function () {
      requestAnimationFrame(syncViewport);
    });

    /*
      Reading computed styles for every descendant is intentionally delayed
      until the intro and its carousel handoff are over. Running this at
      1.2s used to collide with the film-frame construction on slower Macs.
    */

    var promotionScanQueued = false;

    function queuePromotionScan() {
      if (promotionScanQueued) return;
      promotionScanQueued = true;

      window.setTimeout(function () {
        var runPromotionScan = function () {
          scanPromotions(document);
          syncPromotions();
        };

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(runPromotionScan, { timeout: 3000 });
        } else {
          window.setTimeout(runPromotionScan, 1000);
        }
      }, 2500);
    }

    /* The homepage contains several large carousels. Walking every one of
       their descendants is more expensive than leaving layer selection to
       the browser, so promotion scanning is only used on ordinary pages. */
    if (!document.querySelector('.ak-film-simple-section, section.ak-featured-carousel')) {
      queuePromotionScan();
    }

    [500].forEach(function (delay) {
      window.setTimeout(syncViewport, delay);
    });

    document.addEventListener('visibilitychange', function () {
      syncViewport();
      syncPromotions();
    });
    /* Videos and managed animations already have their own
       IntersectionObservers. Running syncViewport() on every scroll frame
       duplicated that work and forced repeated style/layout reads across
       every homepage carousel while Kingpong was animating. */
    window.addEventListener('resize', queueViewportSync, { passive: true });
    window.addEventListener('load', syncViewport, { once: true });
    window.addEventListener('pageshow', syncViewport);
    window.addEventListener('ak:browser-resume',function(){
      if(viewportFrame!==null){cancelAnimationFrame(viewportFrame);viewportFrame=null;}
      syncViewport();syncPromotions();
    });
    window.addEventListener('ak:film-removed', queueViewportSync);
    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* Homepage image loading and decoding now belong to AK_BOOT. There is no
   second image-warmup pass competing with the first scroll after the intro. */

/* A moved touch is a scroll/swipe, not a click. Safari can otherwise emit a
   click on the card or link under the finger when momentum stops. */
(function () {
  'use strict';

  if (window.__AK_MOBILE_GESTURE_CLICK_GUARD__) return;
  window.__AK_MOBILE_GESTURE_CLICK_GUARD__ = true;

  var startX = null;
  var startY = null;
  var startScrollY = 0;
  var moved = false;
  var suppressNextClick = false;

  function isActive() {
    return window.innerWidth <= 1200 &&
      document.body &&
      document.body.classList.contains('ak-page-index');
  }

  document.addEventListener('touchstart', function (event) {
    if (!isActive() || event.touches.length !== 1) return;

    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
    startScrollY = window.scrollY || 0;
    moved = false;
    suppressNextClick = false;
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', function (event) {
    if (!isActive() || startX === null || event.touches.length !== 1) return;

    var deltaX = Math.abs(event.touches[0].clientX - startX);
    var deltaY = Math.abs(event.touches[0].clientY - startY);

    if (deltaX > 7 || deltaY > 7 ||
        Math.abs((window.scrollY || 0) - startScrollY) > 3) {
      moved = true;
    }
  }, { passive: true, capture: true });

  document.addEventListener('touchend', function () {
    if (!isActive()) return;

    suppressNextClick = moved;
    startX = null;
    startY = null;
    moved = false;

    if (suppressNextClick) {
      window.setTimeout(function () {
        suppressNextClick = false;
      }, 700);
    }
  }, { passive: true, capture: true });

  document.addEventListener('touchcancel', function () {
    startX = null;
    startY = null;
    moved = false;
    suppressNextClick = false;
  }, { passive: true, capture: true });

  document.addEventListener('click', function (event) {
    if (!isActive() || !suppressNextClick || event.detail === 0) return;

    suppressNextClick = false;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
})();
